(function ($) {
  $(() => {
    $(document).on('submit', 'form#mailjetSubscriptionForm', function (event) {
      event.preventDefault();

      const form = $(this);
      const message = $('.mailjet_widget_form_message');
      $('.mj_form_property').removeClass('has-error');

      jQuery.ajax({
        url: mjWidget.ajax_url,
        type: 'post',
        data: form.serializeArray(),
        success(response) {
          try {
            const data = JSON.parse(response);

            if (data.prop_errors) {
              $.each(data.prop_errors, function () {
                const propInput = $(`.mj_form_property[name="properties[${this}]"]`);
                propInput.addClass('has-error');
              });
            }
          } catch (e) {
            alert(response);
          }
        },
        error(err) {
          message.text('An error occurred.');
        },
      });
    });

    $('.mj-rgpd-button').on('click', function (e) {
      $(this).parent().find('.mailjet-rgpd').toggleClass('hidden');
    });
  });
}(jQuery));
